(() => {
  const isMobile = document.querySelector('html').dataset.typePlatform === 'mobile';
  const isPersonalPages = window.location.pathname.includes('personal');
  const isContactsPages = window.location.pathname.includes('contacts');

  const isFrom = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchFrom = searchParams.get('from');
    return !!searchFrom;
  };

  const widgetId = 'X1I9Jp9tMk';
  const isRenderJivoWidget = !isPersonalPages && !isMobile && !isFrom();

  function createJivoSiteScript() {
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = `//code.jivosite.com/script/widget/${widgetId}`;
    const ss = document.getElementsByTagName('script')[0];
    ss.parentNode.insertBefore(s, ss);
  }

  if (isRenderJivoWidget) {
    const jivositeText = 'Напишите нам, мы онлайн!';
    const jivositeLoading = 'Загрузка...';
    const jivositeClassStub = 'fake-jivosite';

    window.jivo_onLoadCallback = () => {
      const el = document.getElementsByClassName(jivositeClassStub)[0];
      if (el) {
        el.innerText = jivositeText;
        el.style.display = 'none';
        // eslint-disable-next-line
        jivo_api.open();
      }
    };

    window.onload = () => {
      const el = document.createElement('div');
      function loadJivoSite() {
        el.innerText = jivositeLoading;
        createJivoSiteScript();
      }

      el.classList.add(jivositeClassStub);
      el.innerText = jivositeText;

      document.body.insertBefore(el, document.body.firstChild);

      let isAlreadyClicked = false;

      el.addEventListener('click', () => {
        if (!isAlreadyClicked) {
          isAlreadyClicked = true;
          loadJivoSite();
        }
      });
    };
  } else if (isContactsPages && isMobile && !isFrom()) {
    createJivoSiteScript();

    const $jivoSiteCallEl = document.querySelector('.js-call-jivosite');

    if ($jivoSiteCallEl) {
      $jivoSiteCallEl.addEventListener('click', () => {
        // eslint-disable-next-line
        jivo_api.open();
      });
    }
  }
})();
